var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative","height":"40vh","width":"80vw"}},[_c('canvas',{attrs:{"id":"chart"}})])
}]

export { render, staticRenderFns }